import { render } from "./PageViewEscrito1.vue?vue&type=template&id=f427e12c"
import script from "./PageViewEscrito1.vue?vue&type=script&lang=js"
export * from "./PageViewEscrito1.vue?vue&type=script&lang=js"

import "./PageViewEscrito1.vue?vue&type=style&index=0&id=f427e12c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__